"use strict";
/**
 * Copyright © 2020 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withRichtextPlainSerializer = exports.useRichtextPlainSerializer = void 0;

var react_1 = __importDefault(require("react"));

var lodash_1 = require("lodash");

var core_1 = require("@bodiless/core");

var slate_1 = require("slate");

var DEFAULT_DELIMITER = '\n';
/**
 * @todo make delimiter configurable similar to how it was done in slate-plain-serializer
 * @see https://github.com/ianstormtaylor/slate/blob/slate%400.44.13/packages/slate-plain-serializer/src/index.js#L19
 */

var serialize = function serialize(nodes) {
  return nodes.map(function (n) {
    return slate_1.Node.string(n);
  }).join(DEFAULT_DELIMITER);
};

var useRichtextPlainSerializer = function useRichtextPlainSerializer() {
  var node = core_1.useNode().node;
  var value = node.data;
  return value ? serialize(value) : '';
};

exports.useRichtextPlainSerializer = useRichtextPlainSerializer;

var withRichtextPlainSerializer$ = function withRichtextPlainSerializer$(Component) {
  var WithRichtextPlainSerializer = function WithRichtextPlainSerializer(props) {
    var plainData = useRichtextPlainSerializer();
    return react_1.default.createElement(Component, __assign({}, props), plainData);
  };

  return WithRichtextPlainSerializer;
};

var withRichtextPlainSerializer = lodash_1.flowRight(core_1.withNode, withRichtextPlainSerializer$);
exports.withRichtextPlainSerializer = withRichtextPlainSerializer;